//socket.js
import { io } from "socket.io-client";

let socket;

/**
 * Initializes or retrieves the singleton socket instance.
 * Always sets the auth token if provided.
 * @param {string} [token] - Optional JWT to pass to the signaling server
 * @returns {socket} - Initialized or existing Socket.IO instance
 */
function getSocket(token) {
  if (!socket) {
    console.log("🚀 Initializing new WebSocket connection...");

    const isLocalDev = window.location.hostname === "localhost";
    const socketUrl = isLocalDev
      ? "http://localhost:3002"
      : `https://${window.location.hostname}`;

    console.log("🔐 Creating socket with token:", token);

    socket = io(socketUrl, {
      autoConnect: false,
      transports: ["websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
      auth: { token },
    });

    socket.on("connect", () => {
      console.log("✅ Connected with ID:", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.error("⚠️ Socket connection error:", err.message || err);
    });

    socket.on("disconnect", (reason) => {
      console.log("🔌 WebSocket disconnected. Reason:", reason);
    });
  }

  // ✅ Explicitly connect after setup
  if (!socket.connected) {
    socket.connect();
  }

  return socket;
}

function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export { getSocket, disconnectSocket };

